module.exports = __webpack_public_path__ + "static/scale-model-of-magic-bus-san-francisco-in-berkeley-california-289a2f8add22db97175c60fb191a89a8.png";